var render = function render(){var _vm=this,_c=_vm._self._c;return _c('binds-ripple',{staticClass:"binds-list-item-content",attrs:{"binds-disabled":_vm.bindsDisabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }